export default {
  closeButton: 'prime-promotional-banner-close-button',
};
